import { isEmpty, map, take } from 'lodash/fp';

import { CONTENT_SECTIONS } from '../../../content/sections';
import { ValuePropositionsObject } from '../../../../../types/__codegen__/sanity/graphql';
import getImageAttributes from '../../../../../cms/utils/get-image-attributes';

type MapValuePropositionsContentProps = {
  cmsSectionContent: ValuePropositionsObject & {
    orderIndex: number;
  };
};

const mapValuePropositionsContent = ({ cmsSectionContent }: MapValuePropositionsContentProps) => {
  if (isEmpty(cmsSectionContent)) {
    return null;
  }
  // Displaying no more than 6 tiles as per design requirement
  const propositionsToShow = take(6, cmsSectionContent.valuePropositionsReference);
  const mappedCmsContent = {
    cta: {
      title: cmsSectionContent.urlObject?.name,
      to: cmsSectionContent.urlObject?.url,
    },
    orderIndex: cmsSectionContent.orderIndex,
    tiles: map(
      (valueProposition) => ({
        image: getImageAttributes({ height: 352, imageObject: valueProposition?.imageObject }),
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'summary' does not exist on type 'ValueProposition'.
        summary: valueProposition?.summary,
        title: valueProposition?.name,
        urlObject: valueProposition?.urlObject,
      }),
      propositionsToShow,
    ),
    title: cmsSectionContent.title,
    type: CONTENT_SECTIONS.VALUE_PROPOSITIONS,
    withSimpleBit: false,
  };

  return mappedCmsContent;
};

export default mapValuePropositionsContent;
